import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TermsAndConditionsFacade } from './+state';
import { TermsAndConditionsStateModule } from './+state/terms-and-conditions.state.module';
import { TermsAndConditionsService } from './services/terms-and-conditions.service';

@NgModule({
  imports: [CommonModule, TermsAndConditionsStateModule],
})
export class DomainTermsAndConditionsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainTermsAndConditionsModule,
      providers: [TermsAndConditionsService, TermsAndConditionsFacade],
    };
  }
}
